export enum PartitionKeyEnum {
	A = 'Mietminderung',
	B = 'Mietendeckel',
	C = 'Mietpreisbremse',
	D = 'Mietrechtsanfragen',
	E = 'Nebenkosten',
	F = 'Kaution',
}
